export const cards = [
  {
    url: "transiteye",
    title: "TransitEye",
    subheading:
      "Empowering Urban Transit with Live Passenger Counts, Continuous Surveillance, and Location Intelligence to Make Every Journey Safer, Smarter and Comfortable",
    price: "TBD",
    tags: ["Real-time Tracking", "Passenger Counting", "Transit Analytics"],
    img: ["/Images/Products/transiteye-hero.png", "/Images/Products/transiteye2.png", "/Images/Products/transiteye3.png"],
    data: {
      head: "Our state-of-the-art <span class='accent-color'>passenger counting system</span> meticulously tracks the boarding and alighting of passengers on buses, ensuring a seamless and efficient travel experience. ",
      para: "Designed to integrate flawlessly with existing transit systems, it provides vital data to both transit providers and passengers, facilitating smoother and more reliable journeys. The system adeptly handles simultaneous entries and exits through multiple doors, maintaining an accurate count of passengers at all times. Tailored specifically for Indian scenarios, it leverages data collected from local setups to ensure precision and relevance. A key feature of our system is the calculation of the total number of people inside the bus, delivering this information in real-time to authorities and stakeholders. This ensures optimized bus operations and enhanced passenger safety. The system transmits only the necessary count data in real-time, maintaining a balance between efficiency and privacy. Embrace a new era of intelligent transit solutions with our advanced passenger counting system, designed to revolutionize public transportation in India and beyond.",
    },
    featuresSection: {
      title: "Smarter Journeys, Safer Travels",
      description: "TransitEye is an advanced AI-powered passenger counting and transit intelligence system built on edge computing, designed to transform public transportation in India and beyond. The system accurately tracks passenger boarding and alighting through multiple bus doors simultaneously, maintaining precise real-time occupancy counts at all times. By processing data directly on the device, TransitEye ensures fast performance, minimal bandwidth usage, and enhanced data. Designed specifically for Indian operating conditions, TransitEye leverages locally trained AI models to deliver high accuracy even in crowded and dynamic environments. It plays a crucial role in crowd management and helps reduce revenue leakages by bringing transparency to passenger volumes, supporting transport operators and government agencies in minimizing losses. The system also provides video surveillance, real-time location updates, occupancy alerts for passengers and authorities, and immediate notifications in case of device failures or bus breakdowns. With detailed route-wise and time-wise analytics, TransitEye enables dynamic scheduling, better fleet utilization, and data-driven infrastructure planning.",
      features: [
        {
          icon: "chip",
          title: "AI at the Edge",
          desc: "Runs powerful AI models directly on compact edge devices"
        },
        {
          icon: "alert",
          title: "Real-time Alerts",
          desc: "Automatically notifies authorities of tampering or damage"
        },
        {
          icon: "power",
          title: "Custom Power",
          desc: "Adapts to varied and complex power systems in buses"
        },
        {
          icon: "mobile",
          title: "Wireless Transfer",
          desc: "Send video data peer-to-peer without internet"
        }
      ]
    },
    keyFeaturesSection: {
      title: "Key Features",
      subtitle: "Comprehensive capabilities for intelligent transit management",
      features: [
        {
          icon: "target",
          title: "High Accuracy",
          desc: "95.3% Detection accuracy ensuring reliable passenger counts."
        },
        {
          icon: "turn",
          title: "GPS Tracking",
          desc: "<1m GPS accuracy for precise vehicle location tracking."
        },
        {
          icon: "chip",
          title: "Deep Tech",
          desc: "Next-gen device empowering smarter public transport systems."
        },
        {
          icon: "power",
          title: "Power Backup",
          desc: "Built-in backup keeps system running even when vehicle is off."
        },
        {
          icon: "settings",
          title: "Plug & Play",
          desc: "Quick setup with minimal effort, just plug it in and go."
        },
        {
          icon: "mobile",
          title: "Low Wiring",
          desc: "Designed for cleaner install with fewer cables and hassle."
        }
      ]
    },
    techSpecs: [
      { label: "Accuracy", value: "> 98.5% (Vehicle Classification)" },
      { label: "Power", value: "24V 2A vehicular supply" },
      { label: "Connectivity", value: "4G" },
      { label: "Processing", value: "Edge Computing" }
    ],
    howItWorks: [
      { step: 1, title: "Install", desc: "Mount device and cameras on vehicle interior", icon: "install" },
      { step: 2, title: "Connect", desc: "Connect power source (direct vehicle supply)", icon: "connect" },
      { step: 3, title: "Configure", desc: "Customise regions and data (vehicle specific)", icon: "analyze" },
      { step: 4, title: "Control", desc: "Process data in the Edge (no manual intervention)", icon: "optimize" },
      { step: 5, title: "Visualise", desc: "View and download data through web application", icon: "download" }
    ],
    useCases: [
      { title: "Public Bus Transit", image: "/Images/Products/public-bus.png" },
      { title: "Occupancy Analysis", image: "/Images/Products/occupancy.png" },
      { title: "Route Scheduling", image: "/Images/Products/route-bus.jpg" }
    ],
    realDeployments: {
      stats: [
        { label: "Buses Deployed", value: "1,200+" },
        { label: "Miles Monitored", value: "5M+" },
        { label: "Fuel Saved", value: "15%" }
      ],
      image: "https://images.unsplash.com/photo-1570125909232-eb263c188f7e?auto=format&fit=crop&w=800&q=80",
      dashboardImage: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=800&q=80"
    }
  },
  {
    id: 2,
    url: "crowdeye",
    title: "CrowdEye",
    subheading: "AI-powered edge analytics system that monitors crowd density, movement patterns, and safety risks in real time, enabling authorities to manage events, public spaces, and emergency situations efficiently.",
    price: "Custom",
    img: ["/Images/Products/crowdeye-product.png"],
    tags: ["Edge Computing", "Crowd Management", "Real Time Monitoring"],
    data: {
      head: "CrowdEye: Intelligent Human Density Analysis",
      para: "Ensures public safety and optimizes flow in high-density areas. Using advanced computer vision, CrowdEye detects crowd density, abnormal behavior, and stampede risks in real-time."
    },
    keyFeaturesSection: {
      title: "Optimize Flow & Safety",
      subtitle: "Powerful crowd analytics for modern venues",
      features: [
          { icon: "people", 
            title: "Person Counting", 
            desc: "Counting accuracy of 98% " 
        },
          { icon: "alert", 
            title: "Diagonostic Alerts", 
            desc: "Alerts on any tampering, power loss or failure" 
        },
          { icon: "camera", 
            title: "All weather Vision", 
            desc: "AI powered all weather and Day & Night vision" 
        },
        {
            icon: "power",
            title: "Dual Power",
            desc: "Works on Solar and AC with 24-hr backup."
          },
          {
            icon: "shield",
            title: "Urban Ready",
            desc: "Compact design, easily mounted on poles."
          },
          {
            icon: "mobile",
            title: "App Control",
            desc: "Monitor and control via intuitive mobile app."
          }
      ]
    },

    techSpecs: [
      { label: "Detection Accuracy", value: "94%" },
      { label: "Counting Accuracy", value: "98%" },
      { label: "Power Source", value: "Solar or AC" },
      { label: "Battery Backup", value: "Customizable (24-Hourby default)" },
      { label: "Processing", value: "Edge Computing" },
      { label: "Connectivity", value: "Mobile App & Cloud Dashboard" }
    ],
    howItWorks: [
      { step: 1, title: "Install", desc: "Mount on poles or stands at the location", icon: "install" },
      { step: 2, title: "Connect", desc: "Connect to Power Source (Solar or AC supply)", icon: "connect" },
      { step: 3, title: "Configure", desc: "Customise regions and data (location specific)", icon: "analyze" },
      { step: 4, title: "Control", desc: "Process data in the Edge (no manual intervention)", icon: "optimize" },
      { step: 5, title: "Visualise", desc: "View and download data through web application", icon: "download" }
    ],
    useCases: [
      { title: "Stadiums & Events", image: "/Images/Products/crowd.png" },
      { title: "Auditoriums", image: "/Images/Products/auditorium.png" },
      { title: "Pilgrimage Sites", image: "/Images/Products/pilgrimage-site.jpg" }
    ],
    realDeployments: {
      stats: [
        { label: "Venues Secured", value: "50+" },
        { label: "Events Managed", value: "10M+ People" },
        { label: "Incidents Prevented", value: "100%" }
      ],
      image: "https://images.unsplash.com/photo-1533174072551-2780e02798e4?auto=format&fit=crop&w=800&q=80",
      dashboardImage: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=800&q=80"
    }
  },
  {
    id: 3,
    url: "video-analytics",
    title: "Video Analytics using ITD",
    subheading:
      "Our advanced software transforms raw video feeds into actionable insights,delivering real-time analytics for turning movements, traffic flow, lane behavior,ANPR,violation detection, and safety assessments all aligned with Indo-HCM standards.Optimize road performance, enhance safety, and enable data-driven decision-making with cutting-edge AI-powered solutions",
    price: "TBD",
    tags: ["Traffic Insights", "Vehicle Counting", "AI Analysis"],
    img: ["/Images/Products/video-analytics.png"],
    data: {
      head: "With the Indian Traffic Dataset, <span class='accent-color'>PARIMITRA</span> provide an essential tool for researchers and practitioners alike, fostering advancements in traffic management and intelligent transportation systems, particularly tailored to the unique dynamics of developing economies.",
      para: "Efficient transportation is essential for national progress. Modern Intelligent Transportation Systems (ITS) rely on large-scale driving datasets, but existing datasets fall short in addressing the diverse vehicle types found in developing economies like India and in utilizing real-world video and image data from static cameras. To bridge this gap, we present the Indian Traffic Dataset (ITD). <br /> <br />The ITD captures the diverse traffic of India, featuring a variety of vehicles from different regions. It includes 10,500+ annotated images spanning nine distinct classes and nearly 306,000+  annotated objects. Unique to ITD is the comprehensive labeling of vehicle classes according to the Indian Highway Capacity Manual (INDO-HCM), making it especially relevant for South and Southeast Asian countries with similar traffic landscapes. <br /> <br />Validated with no significant difference between observed and predicted traffic volumes at a 5% significance level, the ITD covers a wide range of traffic conditions. It supports tasks such as vehicle counting, traffic flow analysis, trajectory analysis, safety assessments, and traffic violation detection, making it an invaluable resource for various ITS applications.",
    },
    featuresSection: {
      title: "Advanced Video Analytics",
      description: "Existing datasets fall short in addressing the diverse vehicle types found in developing economies like India and in utilizing real-world video and image data from static cameras. To bridge this gap, we present the Indian Traffic Dataset (ITD). The ITD captures the diverse traffic of India, featuring a variety of vehicles from different regions. It includes 10,500+ annotated images spanning nine distinct classes and nearly 306,000+ annotated objects. Unique to ITD is the comprehensive labeling of vehicle classes according to the Indian Highway Capacity Manual (INDO-HCM), making it especially relevant for South and Southeast Asian countries with similar traffic landscapes. Validated with no significant difference between observed and predicted traffic volumes at a 5% significance level, the ITD covers a wide range of traffic conditions. It supports tasks such as vehicle counting, traffic flow analysis, trajectory analysis, safety assessments, and traffic violation detection, making it an invaluable resource for various ITS applications.",
      features: [
        {
          icon: "turn",
          title: "Turning Counts",
          desc: "Measure movements through approaches of the intersections"
        },
        {
          icon: "warning",
          title: "Violation Detection",
          desc: "Identify traffic and lane violations on road accurately"
        },
        {
          icon: "camera",
          title: "ANPR",
          desc: "Capture and recognise license plate informations "
        },
        {
          icon: "list",
          title: "Queue Length Estimation",
          desc: "Estimate queue lenghts for efficient traffic management"
        }
      ]
    },
    keyFeaturesSection: {
      title: "Key Features",
      subtitle: "Comprehensive capabilities for intelligent traffic management",
      features: [
        {
          icon: "turn",
          title: "Turning Movements",
          desc: "Left, right, and through movement counts."
        },
        {
          icon: "turn",
          title: "Entry/Exit",
          desc: "Simultaneous monitoring to evaluate capacity."
        },
        {
          icon: "list",
          title: "Lane Analysis",
          desc: "Detailed lane-based feature extraction."
        },
        {
          icon: "camera",
          title: "ANPR",
          desc: "License plate recognition for identification."
        },
        {
          icon: "warning",
          title: "Violation Detection",
          desc: "Detects overtaking and lane violations."
        },
        {
          icon: "shield",
          title: "Safety Assessment",
          desc: "Determine Time-to-Collision and critical metrics."
        }
      ]
    },
    techSpecs: [
      { label: "Dataset Size", value: "10,500+ Annotated Images" },
      { label: "Object Count", value: "306,000+ Labeled Objects" },
      { label: "Classification", value: "Indo-HCM Standard (9 Classes)" },
      { label: "Coverage", value: "25+ Locations across 14 States" },
      { label: "Applications", value: "Volume, Flow, Safety, Violation" }
    ],
    howItWorks: [
      { step: 1, title: "Input", desc: "Upload raw traffic video feeds or real-time camera stream.", icon: "install" },
      { step: 2, title: "Configure", desc: "Customise regions and data (location specific)", icon: "analyze" },
      { step: 3, title: "Process", desc: "AI models analyze vehicle types and movements.", icon: "optimize" },
      { step: 4, title: "Report", desc: "Generate counts, violation reports, and safety metrics.", icon: "download" }
    ],
    useCases: [
      { title: "Turning Movements", image:"/Images/Products/turning-movements.png"},
      { title: "Violations", image: "/Images/Products/traffic-violations.png"},
      { title: "Traffic Analytics", image: "/Images/Products/traffic-analysis.png" }
    ],
    realDeployments: {
      image: "https://images.unsplash.com/photo-1563363402-4d926315ee6b?auto=format&fit=crop&w=800&q=80",
      dashboardImage: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=800&q=80",
      stats: [
        { value: "306k+", label: "Objects Labeled" },
        { value: "25+", label: "Locations" },
        { value: "14", label: "States Covered" },
        { value: "95%", label: "Validation Accuracy" }
      ]
    }
  },
  {
    url: "trafficeye",
    title: "TrafficEye",
    subheading:
      "AI powered, camera-based edge device designed for live traffic analysis capable of vehicle counting, turning movement detection, speed measurement, traffic violation monitoring, surrogate safety assessment, and comprehensive traffic flow analysis.",
    price: "TBD",
    tags: ["Real-time Analytics", "Edge AI", "Standalone"],
    img: ["/Images/Products/trafficeye-product.png"],
    data: {
      head: "An <span class='accent-color'>AI-powered, camera-based edge device</span> for real-time traffic analysis, enabling vehicle counting, speed measurement, turning movement detection, and traffic violation monitoring.",
      para: "This intelligent edge device leverages AI and computer vision to provide real-time insights into urban traffic conditions. By processing video feeds directly at the source, it accurately counts vehicles, measures their speed, identifies turning movements, and flags potential traffic violations. Designed for deployment at intersections, highways, and urban choke points, it helps city planners, law enforcement, and transport authorities make data-driven decisions to enhance road safety, reduce congestion, and optimize traffic flow.",
    },
    featuresSection: {
      title: "Intelligent Traffic Analysis",
      description: "Trafficeye is a standalone edge AI device designed as a modular building block for a wide range of traffic and transportation applications. From intelligent parking management and violation detection to traffic surveys and mobility analytics, Trafficeye enables multiple use cases through a single adaptable platform. At its core lies a powerful, customizable computer vision engine that can be tailored to specific user requirements. All processing is performed on the edge, ensuring data privacy, reduced bandwidth usage, and transmission of only minimal, relevant information as defined by the user. The device is designed for easy retrofitting and can be mounted on poles, trees, or existing roadside infrastructure using simple tools, eliminating the need for heavy civil or network-intensive installations. Compared to conventional infrastructure-heavy solutions in the market, Trafficeye offers a significantly more cost-effective alternative while delivering superior accuracy and operational flexibility.",
      features: [
        {
          icon: "chip",
          title: "AI at the Edge",
          desc: "Real-time intelligence locally"
        },
        {
          icon: "power",
          title: "Dual Power Support",
          desc: "Operates on Solar and AC supply"
        },
        {
          icon: "mobile",
          title: "App Control",
          desc: "Setup, monitor, and control via intuitive mobile app"
        },
        {
          icon: "target",
          title: "Indian Road Ready",
          desc: "Trained on custom Indian Traffic Dataset"
        }
      ]
    },
    keyFeaturesSection: {
      title: "Key Features",
      subtitle: "Robust hardware for demanding urban environments",
      features: [
        {
          icon: "target",
          title: "High Accuracy",
          desc: "91.3% Detection and 95% Counting accuracy."
        },
        {
          icon: "power",
          title: "Dual Power",
          desc: "Works on Solar and AC with 24-hr backup."
        },
        {
          icon: "shield",
          title: "Urban Ready",
          desc: "Compact design, easily mounted on poles."
        },
        {
          icon: "mobile",
          title: "App Control",
          desc: "Monitor and control via intuitive mobile app."
        },
        {
          icon: "chip",
          title: "Edge AI",
          desc: "No cloud reliance, real-time local processing."
        },
        {
          icon: "settings",
          title: "Low Maintenance",
          desc: "Minimal wiring ensures efficiency and easy install."
        }
      ]
    },
    techSpecs: [
      { label: "Detection Accuracy", value: "91.3%" },
      { label: "Counting Accuracy", value: "95%" },
      { label: "Power Source", value: "Solar or AC" },
      { label: "Battery Backup", value: "Customizable (24-Hourby default)" },
      { label: "Processing", value: "Edge Computing" },
      { label: "Connectivity", value: "Mobile App & Cloud Dashboard" }
    ],
    howItWorks: [
      { step: 1, title: "Install", desc: "Mount on poles or stands at the location", icon: "install" },
      { step: 2, title: "Connect", desc: "Connect to Power Source (Solar or AC supply)", icon: "connect" },
      { step: 3, title: "Configure", desc: "Customise regions and data (location specific)", icon: "analyze" },
      { step: 4, title: "Control", desc: "Process data in the Edge (no manual intervention)", icon: "optimize" },
      { step: 5, title: "Visualise", desc: "View and download data through web application", icon: "download" }
    ],
    useCases: [
      { title: "Parking Management", image: "/Images/Products/parking.png" },
      { title: "Survey", image: "/Images/Products/survey.png" },
      { title: "Traffic Analytics", image: "/Images/Products/traffic-counting.jpg" }
    ],
    realDeployments: {
      image: "https://images.unsplash.com/photo-1494515843206-f3117d3f51b7?auto=format&fit=crop&w=800&q=80",
      dashboardImage: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=800&q=80",
      stats: [
        { value: "95%", label: "Counting Accuracy" },
        { value: "91.3%", label: "Detection Accuracy" },
        { value: "24h", label: "Power Backup" },
        { value: "0", label: "Cloud Dependency" }
      ]
    }
  },
]

export const projects = [
  {
    url: "haridwarkanwar",
    title: "CrowdEye in Haridwar during Kanwar 2024",
    subheading:
      "Effortlessly track the crowd density at a particular location.",
    price: "TBD",
    img: ["/Images/Projects/haridwar1.png", "/Images/Projects/haridwar2.png", "/Images/Projects/haridwar3.png", "/Images/Projects/haridwar4.png", "/Images/Projects/haridwar5.png"],
    data: {
      head: "<span class='accent-color'>Real-time Crowd Monitoring</span> for Safer Pilgrimages and Smarter Management",
      para: "Implementing proactive crowd management strategies will be pivotal in regulating crowd assessment and overcrowding and enhancing safety at these revered sites. The efficacy of these systems can be rigorously evaluated through field trials and real-world deployments. Hinduism features numerous pilgrimages, and one of the most popular is the Kanwar Yatra, also known as the Kawad Yatra at Haridwar, Uttarakhand, which attracts millions of devotees from across India during the holy month of Shravan (Sawan). In 2024, the Kanwar Yatra occurred from July 22 to August 02. A large influx of devotees during this period often leads to significant congestion and safety risks, particularly along critical points of the pilgrimage route and at the sites where they fetch the holy water. During the two-week period using the CrowdEye, more than 2.5 million pilgrims were counted. To monitor heavy influx and occupancy, real-time alerts were sent to local authorities for better crowd management.",
    },
  },
  {
    url: "trafficeye-meerut",
    title: "TrafficEye in Meerut for Turning Movement Counts",
    subheading:
      "Deployed at key intersections, this AI-powered system captures turning movement data in Meerut",
    price: "TBD",
    img: ["/Images/Projects/meerut1.jpg", "/Images/Projects/meerut2.png", "/Images/Projects/meerut3.png"],
    data: {
      head: "AI-powered <span class='accent-color'>Traffic Data Extraction System</span> for Accurate Vehicular Movement Analysis in Meerut.",
      para: "For a study on air pollution in Meerut city, the turning vehicular count data from 10 intersections in Meerut city were to be extracted. For every approach in the intersection, the classified count of the vehicles at each approach as per the Indo HCM is extracted. The device consists of a processing unit connected to an IP-based camera. The power distribution setup in the central processing unit powers up the processor and the cameras connected to it. The Object detection model trained on the Indian traffic Dataset (ITD) showed an impressive accuracy compared to the ground truth and XL model on GPU.",
    },
  },
]

export const team = [
  {
    name: "Dr. Amit Agarwal",
    designation: "Founder & Director",
    linkedin: "https://www.linkedin.com/in/amit-agarwal-99a20232/",
    email: "amitfce@iitr.ac.in",
    img: "/Images/Team/Leadership/amit.jpg",
    bio: "Associate Professor at the Indian Institute of Technology Roorkee, with extensive academic and industry experience. Previously served as a Research Scientist at Robert Bosch Singapore, bringing strong expertise in Intelligent Transportation Systems (ITS) and applied research.",
  },
  {
    name: "Mr. Karthik Krishnan O",
    designation: "CoFounder & Director",
    linkedin:
      "https://www.linkedin.com/in/karthik-krishnan-o-75846920b/",
    email: "karthikkrishnanozhinhala@gmail.com",
    img: "/Images/Team/Leadership/karthik.jpg",
    bio: "Young entrepreneur with a focus on Artificial Intelligence, Cyber-Physical Systems, and autonomous vehicles. Previously worked as a Project Associate at the Indian Institute of Technology Roorkee, gaining hands-on experience in research and applied technology development.",
  },
  {
    name: "Mrs. Vandana Gupta",
    designation: "Cofounder & Director",
    linkedin:
      "https://in.linkedin.com/company/parimitra",
    email: "riteshsingh9827@gmail.com",
    img: "/Images/Team/Leadership/vandana.png",
    bio: "A dynamic entrepreneur who drives business strategy, human resources, financial planning, operations management, partnerships, and organizational growth. She focuses on building scalable ventures, fostering strong teams, and delivering sustainable business impact.",
  },
  {
    name: "Mr. Ritesh Singh",
    designation: "Product strategist ",
    linkedin:
      "https://www.linkedin.com/in/ritesh-singh-b912b1217/",
    email: "riteshsingh9827@gmail.com",
    img: "/Images/Team/Leadership/ritesh.jpg",
    bio: "Excellent expertise in Artificial Intelligence, Computer Vision, deep learning, edge AI deployment, and real-time perception systems. Previously worked as a Project Associate at the Indian Institute of Technology Roorkee, contributing to advanced research.",
  },
  
]

export const engineeringTeam = [
  {
    name: "Michael Zhang",
    designation: "Lead AI Engineer",
    img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=400&q=80",
    bio: "Computer vision specialist focused on real-time traffic analysis and predictive modeling.",
  },
  {
    name: "Emma Rodriguez",
    designation: "Senior Backend Engineer",
    img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=400&q=80",
    bio: "Scalable systems architect with expertise in cloud infrastructure and real-time data processing.",
  },
  {
    name: "David Kim",
    designation: "IoT Systems Engineer",
    img: "https://images.unsplash.com/photo-1542909168-82c3e7fdca5c?auto=format&fit=crop&w=400&q=80",
    bio: "Hardware integration expert specializing in smart sensors and edge computing solutions.",
  },
  {
    name: "Lisa Thompson",
    designation: "Frontend Engineer",
    img: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=400&q=80",
    bio: "UX-focused developer creating intuitive interfaces for complex transportation data.",
  },
]

export const advisoryBoard = [
  {
    name: "Dr. James Wilson",
    designation: "Former VP of Engineering, Waymo",
    img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=400&q=80",
    bio: "Pioneer in autonomous vehicle technology with 20+ years experience in developing self-driving systems at scale.",
  },
  {
    name: "Maria Gonzalez",
    designation: "Smart Cities Consultant",
    img: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=400&q=80",
    bio: "Urban planning expert who has advised 50+ cities globally on implementing intelligent transportation infrastructure.",
  },
  {
    name: "Robert Chang",
    designation: "Former CTO, Uber",
    img: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=400&q=80",
    bio: "Scaling expert who built the technology infrastructure that powers millions of daily rides worldwide.",
  },
]
